import { useLoginManagerMutation } from '@/api/api.slice.tsx';
import { __ARS_LEGACY_URL__ } from '@/api/constants.ts';
import { Logger, toastError } from '@arsnovasystems/ars-front-lib';
import i18next from 'i18next';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook allowing connexion to a user account
 *
 * This returns a trigger function that will open the TinyMDM console in a new tab
 * connected to the user account
 *
 * @param props              props of the component
 * @param props.userPublicId the public id of the user
 *
 * @returns                  void
 */
export const useConnectToUserAccount = ({
  userPublicId,
}: {
  userPublicId: string;
}) => {
  const { t } = useTranslation();
  const [loginManager] = useLoginManagerMutation();

  return useCallback(async () => {
    const response = await loginManager(userPublicId);
    if (response.error) {
      toastError({
        description: t('ik.partner.user.loginManager.accountNotReady'),
      });
      Logger.warn('Error while logging in TinyMDM console', response);
      return;
    }

    const urlStr =
      !response.data.nextStep ?
        `${__ARS_LEGACY_URL__}#dashboard:default`
      : `${__ARS_LEGACY_URL__}?nextstep=${response.data.nextStep}#login:url-next-step`;

    // window.open(urlStr, '_blank');

    try {
      const url = new URL(urlStr);
      url.searchParams.set('force-locale', i18next.language.substring(0, 2));
      window.open(url, '_blank');
    } catch (error) {
      console.error(`Error while opening TinyMDM console on ${urlStr}`, error);
    }
  }, [loginManager, t, userPublicId]);
};
